import { saveChuckMode } from "../../utils/storageUtils";

const CHUCK_NORRIS_QUOTES = [
    "Chuck Norris doesn't read books. He stares them down until he gets the information he wants.",
    "Time waits for no man. Unless that man is Chuck Norris.",
    "When Chuck Norris does a pushup, he isn't lifting himself up, he's pushing the Earth down.",
    "Chuck Norris can divide by zero.",
    "Chuck Norris doesn't wear a watch. He decides what time it is.",
    "When the Boogeyman goes to sleep every night, he checks his closet for Chuck Norris.",
    "Chuck Norris counted to infinity... twice.",
    "Chuck Norris can slam a revolving door.",
    "Chuck Norris doesn't call the wrong number. You answer the wrong phone.",
    "Chuck Norris can delete the Recycling Bin.",
    "Chuck Norris can hear sign language.",
    "When Chuck Norris enters a room, he doesn't turn the lights on, he turns the dark off.",
    "Chuck Norris makes onions cry.",
    "Chuck Norris can speak Braille.",
    "Chuck Norris can build a snowman out of rain.",
    "Chuck Norris's tears cure cancer. Too bad he has never cried.",
    "Chuck Norris doesn't need a keyboard, he stares at the computer until it does what he wants.",
    "Chuck Norris can strangle you with a cordless phone.",
    "Chuck Norris doesn't do push-ups, he pushes the Earth down.",
    "Chuck Norris can kill two stones with one bird.",
    "Chuck Norris's computer has no backspace button, Chuck Norris doesn't make mistakes.",
    "Chuck Norris can play the violin with a piano.",
    "Chuck Norris once kicked a horse in the chin. Its descendants are now known as giraffes.",
    "Chuck Norris can light a fire by rubbing two ice cubes together.",
    "When Chuck Norris was born, he drove his mom home from the hospital.",
    "Chuck Norris can win a game of Connect Four in three moves.",
    "Chuck Norris's beard can type 140 words per minute.",
    "Chuck Norris can speak French... in Russian.",
    "Chuck Norris doesn't wear a watch because time is always on his side.",
    "Chuck Norris once won a game of chess in one move.",
    "Chuck Norris can do a wheelie on a unicycle.",
    "Chuck Norris can fold a fitted sheet.",
    "Chuck Norris can blow bubbles with beef jerky.",
    "Chuck Norris doesn't need an umbrella, the rain avoids him.",
    "Chuck Norris can eat just one Lay's potato chip.",
    "Chuck Norris can gargle peanut butter.",
    "Chuck Norris's shadow has been known to roundhouse kick people.",
    "Chuck Norris can slam a revolving door.",
    "Chuck Norris can cut through a hot knife with butter.",
    "Chuck Norris counted to infinity. Twice. Backwards.",
    "Chuck Norris can download emails with a paper clip.",
    "Chuck Norris's calendar goes straight from March 31st to April 2nd. No one fools Chuck Norris.",
    "Chuck Norris can make a happy meal cry.",
    "Chuck Norris can unscramble an egg.",
    "Chuck Norris once got bit by a cobra. After three days of excruciating pain, the cobra died.",
    "Chuck Norris can start a fire with an ice cube.",
    "Chuck Norris's tears can cure the common cold, but he's never cried.",
    "Chuck Norris can pick oranges from an apple tree and make the best lemonade you've ever tasted.",
    "Chuck Norris can find the end of a circle.",
    "Chuck Norris can tell you what color silence tastes like.",
    "Chuck Norris can moonwalk on the sun.",
    "Chuck Norris can write infinite recursion in three lines of code.",
    "Chuck Norris can compile handwritten code.",
    "Chuck Norris's programs don't have bugs, they have features he hasn't decided to remove yet.",
    "Chuck Norris's keyboard doesn't have a Ctrl key because nothing controls Chuck Norris.",
    "Chuck Norris can access private variables.",
    "Chuck Norris can instantiate an abstract class.",
    "Chuck Norris's programs terminate themselves out of respect.",
    "Chuck Norris can write multi-threaded applications with a single thread.",
    "Chuck Norris can solve the Traveling Salesman problem in O(1).",
    "Chuck Norris's code doesn't follow a design pattern, the design pattern follows his code."
];

export const chuckNorrisCommand = (setMessages, setIsChuckMode) => {
    const randomQuote = CHUCK_NORRIS_QUOTES[Math.floor(Math.random() * CHUCK_NORRIS_QUOTES.length)];

    const chuckMessage = {
        id: Date.now() + Math.random(),
        sender: "ai",
        text: `${randomQuote}`,
        displayText: "",
    };

    setMessages(prev => [...prev, chuckMessage]);
    setIsChuckMode(true);
    saveChuckMode(true);
    return true;
}; 